const LIGATURE_EXPANSIONS = {
    ﬀ: "ff",
    ﬁ: "fi",
    ﬂ: "fl",
    ﬃ: "ffi",
    ﬄ: "ffl",
    ﬅ: "st",
    ﬆ: "st"
};
const PDF_LINE_WRAP_HYPHENATION = /([\p{L}\p{N}]+)-[\t\f\v ]*(?:\r\n?|\n)[\t\f\v ]*(?=([\p{L}\p{N}]+))/gu;
// Short fragments are commonly intentional hyphenated prefixes (for example,
// "re-sign"). Without lexical evidence, failing closed is safer than turning
// one word into another. Four-character fragments still cover the known PDF
// line-wrap cases such as "ther-mostat" and "communi-cation".
const MIN_SAFE_LINE_WRAP_FRAGMENT_LENGTH = 4;
/**
 * Normalizes encoding-equivalent evidence text for exact-substring checks.
 * This deliberately does not reorder tokens, apply edit distance, or otherwise
 * turn near matches into evidence.
 */
export function normalizeEvidenceText(value) {
    return value
        .replace(/[“”]/gu, '"')
        .replace(/[‘’]/gu, "'")
        .replace(/[–—]/gu, "-")
        .replace(/[ﬀﬁﬂﬃﬄﬅﬆ]/gu, (ligature) => LIGATURE_EXPANSIONS[ligature] ?? ligature)
        .toLowerCase()
        .replace(/\s+/gu, " ")
        .trim();
}
/**
 * Returns at most two normalized readings of genuine source bytes: the literal
 * rendering and one rendering with eligible hard-hyphen line wraps removed.
 * The alternate reading is bounded to ASCII hyphens at a physical newline with
 * letter/number fragments of at least four code points on both sides; all such
 * wraps are removed together, without lexical guessing or combinatorial forms.
 * Thus `long-\nterm` may render as either `long- term` or `longterm`; this is a
 * source-rendering ambiguity, not fabricated text. Callers must never apply the
 * alternate reading to a claimed quote: after encoding/whitespace normalization,
 * that quote must still match one returned source reading verbatim.
 */
export function normalizeEvidenceSourceTextReadings(value) {
    const literalReading = normalizeEvidenceText(value);
    const dehyphenatedReading = normalizeEvidenceText(value.replace(PDF_LINE_WRAP_HYPHENATION, (lineWrap, prefix, suffix) => [...prefix].length >= MIN_SAFE_LINE_WRAP_FRAGMENT_LENGTH &&
        [...suffix].length >= MIN_SAFE_LINE_WRAP_FRAGMENT_LENGTH
        ? prefix
        : lineWrap));
    return dehyphenatedReading === literalReading
        ? [literalReading]
        : [literalReading, dehyphenatedReading];
}
//# sourceMappingURL=evidenceText.js.map